// extracted by mini-css-extract-plugin
export const sectionLatestListing = "latestListing-module--sectionLatestListing--iVxKv";
export const sectionContent = "latestListing-module--sectionContent--44xIU";
export const sectionBottomBackground = "latestListing-module--sectionBottomBackground--1ZKZp";
export const noResult = "latestListing-module--noResult--3BFTS";
export const listingWrap = "latestListing-module--listingWrap--2w7J_";
export const listingItem = "latestListing-module--listingItem--1f5aT";
export const itemImage = "latestListing-module--itemImage--1iCC6";
export const itemDetails = "latestListing-module--itemDetails--1kP7P";
export const iconsBar = "latestListing-module--iconsBar--1VGnz";
export const itemCta = "latestListing-module--itemCta--WbJLN";